import { useTranslation } from 'react-i18next';
import { motion } from 'motion/react';
import { MessageSquare, Film } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAllComments } from '../api';

export function CommentsPage() {
  const { t } = useTranslation();
  const { data, isLoading } = useAllComments();

  const comments = data?.comments || [];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-5 px-4 sm:px-6 md:px-8"
    >
      <div className="flex items-center justify-between">
        <h1 className="text-lg sm:text-2xl font-semibold">{t('comments.title', 'Comments')}</h1>
        <span className="text-xs text-slate-500">{comments.length} {t('comments.total', 'total')}</span>
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center py-20">
          <p className="text-slate-500">{t('common.loading')}</p>
        </div>
      ) : comments.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <MessageSquare size={32} className="text-slate-300 mb-3" />
          <p className="text-slate-500">{t('comments.empty', 'No comments yet')}</p>
        </div>
      ) : (
        <div className="space-y-3">
          {comments.map((comment: any) => (
            <div
              key={comment.id}
              className="rounded-xl p-4"
              style={{
                background: 'var(--user-page-card-bg)',
                backdropFilter: 'blur(20px)',
                border: '1px solid var(--user-page-card-border)',
              }}
            >
              <div className="flex items-start gap-3">
                <div className="h-8 w-8 flex-shrink-0 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center text-xs font-bold text-white">
                  {comment.author?.firstName?.[0] || '?'}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-semibold text-slate-900">
                      {comment.author?.firstName} {comment.author?.lastName}
                    </span>
                    <span className="text-[10px] text-slate-400">
                      {new Date(comment.createdAt).toLocaleDateString()}
                    </span>
                  </div>
                  <p className="text-sm text-slate-700">{comment.content}</p>
                  {comment.videoTitle && (
                    <Link
                      to={`/videos/${comment.videoId}`}
                      className="mt-2 flex items-center gap-1 text-[10px] text-indigo-500 hover:text-indigo-600"
                    >
                      <Film size={10} />
                      {comment.videoTitle}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </motion.div>
  );
}
